import { TextField, TextFieldProps } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface TextProps {
  name: string;
}

type ExtendedTextFieldProps = TextFieldProps & TextProps;
export function TextFields(props: ExtendedTextFieldProps) {
  const { register } = useFormContext();

  return <TextField {...props} {...register(props.name)} {...props} sx={{ background: 'transparent' }} />;
}
